import { graphql } from "@/lib/gql/__generated__/gql";

export const Voucher_EditPage_Query = graphql(`
	query Voucher_EditPage($hotelID: ID!, $voucherID: ID!) {
		voucher(hotelID: $hotelID, voucherID: $voucherID) {
			id
			hotelID
			voucherID
			inSale
			name
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			voucherPrice {
				currencyType
				amount
			}
			sellingPrice {
				currencyType
				amount
			}
			saleTypeForTerm
			saleStart
			saleEnd
			maxStockNum
			soldNumTotal
			voucherLimitType
			intervalPrepDates
			cinStart
			cinEnd
			deletedAt
		}
	}
`);
